import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { PageWithNavigation } from '../../components';
import OrderPage from './orders';
/**
 * Neo Loan Orders Page
 */
export default () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <>
      <Helmet>
        <title>Neo Loan Orders</title>
      </Helmet>
      <PageWithNavigation>
        <OrderPage
          t={t}
          useSelector={useSelector}
          history={history}
          dispatch={dispatch}
          isOffline
        />
      </PageWithNavigation>
    </>
  );
};